import { useCallback, useState } from "react";

export const useVideo = (localRef, handleLogs, wsRef) => {
  const [isVideoOn, setIsVideoOn] = useState(true);

  /**
   * Toggles the local video track on/off.
   */
  const toggleVideo = useCallback(() => {
    if (localRef.current && localRef.current.srcObject) {
      const videoTrack = localRef.current.srcObject.getVideoTracks()[0];
      if (videoTrack) {
        videoTrack.enabled = !videoTrack.enabled;
        const newState = videoTrack.enabled;
        setIsVideoOn(newState);
        handleLogs(`Video ${newState ? "enabled" : "disabled"}`);

        // Notify other peer about media toggle
        if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
          wsRef.current.send(
            JSON.stringify({
              type: "media_toggle",
              media_type: "video",
              enabled: newState,
            }),
          );
        }
      }
    }
  }, [localRef, handleLogs, wsRef, setIsVideoOn]);
  return { toggleVideo, isVideoOn, setIsVideoOn };
};
